import type { WorkflowExecutionNextAction } from './workflowExecutions.api';

// True when the automation's next step already ran for this candidate, so a move
// must NOT enqueue it into the underway popup.
//
// Sourced from the BE `next_action.already_ran` flag — the BE mirrors its own
// `ExecuteStageAction.already_created?` check (a persisted `AtsApplicationStage
// Action` record for this application + stage action). That's the ONLY reliable
// re-entry signal: on a move out-and-back the BE creates a fresh execution whose
// execution-derived `status` reads `pending` until it's triggered, so `status`
// can't tell "will run" from "already ran" — but the persisted record can.
export const firstStepAlreadyRan = (
  nextAction: WorkflowExecutionNextAction | undefined | null
): boolean => !!nextAction && nextAction.already_ran === true;
